import { render, staticRenderFns } from "./FAQcommunity.vue?vue&type=template&id=7adfed9f&scoped=true"
import script from "./FAQcommunity.vue?vue&type=script&lang=js"
export * from "./FAQcommunity.vue?vue&type=script&lang=js"
import style0 from "./FAQcommunity.vue?vue&type=style&index=0&id=7adfed9f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfed9f",
  null
  
)

export default component.exports